import Vue from 'vue';
import Vuex from 'vuex';
import APIHeaders from './entities/APIHeaders';
// import APIHeaders from '@/entities/APIHeaders'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiHeaders: {},
  },
  mutations: {
    setApiHeaders(state, apiHeaders:APIHeaders) {
      state.apiHeaders = apiHeaders
    },
  },
  actions: {

  },
  getters:{
    apiHeadersOrNull: state => {
      return (APIHeaders.isAPIHeaders(state.apiHeaders)) ?  state.apiHeaders : null
    },
  },
});
